import { Component } from 'react';

import type { ErrorInfo, ReactNode } from 'react';

import { logError } from 'services/logging/logging';

import { ConnectionErrorFallback } from '../ConnectionErrorFallback/ConnectionErrorFallback';

type AgentErrorBoundaryProps = { children: ReactNode };
type AgentErrorBoundaryState = { hasError: boolean };

export class AgentErrorBoundary extends Component<AgentErrorBoundaryProps, AgentErrorBoundaryState> {
  state: AgentErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AgentErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logError(error, { componentStack: info.componentStack, tags: { error_boundary: 'agents_tab' } });
    console.error('AgentErrorBoundary caught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ConnectionErrorFallback />;
    }
    return this.props.children;
  }
}
